import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'

// Parent layout for /issues/* routes. Auth-gates the whole subtree so
// the leaf routes (.index, .$issueId) don't repeat the check. Mirrors
// the entities.tsx / user-management.tsx pattern.
export const Route = createFileRoute('/issues')({
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  component: () => <Outlet />,
})
